<template>
    <div>
        <PageTitle :title="$t('legal.preventa.titulo_condiciones')"/>
        <FirstBanner/>
        <section class="padding-vertical-content pt-0">
            <div class="container">
                <LoaderComponent v-if="loading" />
                <div v-if="evento?.texto_condiciones_legales_preventa" class="row">
                    <div v-html="textoSanitizado"></div>
                </div>
                <div v-else class="row">
                    <div class="col-12">
                        <h3 class="mb-4">{{ $t('legal.preventa.titulo_registro') }}</h3>

                        <p v-for="(p, i) in $t('legal.preventa.texto')" :key="i">
                            - {{ p }}
                        </p>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script setup>
    import PageTitle from '@/components/frontend/shared/PageTitle';
    import FirstBanner from '@/components/frontend/shared/FirstBanner';
    import { onMounted, computed } from 'vue';
    import { useGetEventoDetalle } from '@/composables/common/useGetEventoDetalle';
    import DOMPurify from 'dompurify';
    import { useRoute } from '@/composables/common/router/useRouter';
    import LoaderComponent from '@/components/preloader/LoaderComponent.vue';
    import 'quill/dist/quill.core.css';
    import 'quill/dist/quill.snow.css';
    import 'quill/dist/quill.bubble.css';

    const route = useRoute();
    const id = computed(() => route.params.eventoId);

    // este campo contiene HTML proveniente del backend que debe sanitizarse antes de renderizarse.
    const textoSanitizado = computed(() =>
        evento?.value.texto_condiciones_legales_preventa
            ? DOMPurify.sanitize(evento?.value.texto_condiciones_legales_preventa)
            : '' );

    const { evento, getEvento, loading } = useGetEventoDetalle();

    onMounted(() => {
        if (id.value) {
            getEvento(id.value);
        }
    });
</script>
<style scooped>
    .ql-editor {
        padding: 0;
        overflow: visible;
    }
</style>
